module.exports = __webpack_public_path__ + "media/src/img/hero-flowers-right-213932dbc4c4f268daf30512a5e4148e.png";